"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
var helper_1 = require("./helper");
var ETracker = (function () {
    function ETracker() {
        this.logTag = 'ETracker';
        this.debug = false;
        this.onReport = function (url, data) {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(data)
            });
        };
    }
    ETracker.prototype._monitorClickAction = function () {
        var _this = this;
        document.addEventListener('click', function (event) {
            var target = event.target;
            for (; target && target.tagName !== 'BODY';) {
                var seedId = '';
                var seedName = '';
                var extra = {};
                var attributes = target.attributes;
                for (var i = 0; i < attributes.length; i += 1) {
                    var _a = attributes[i], name_1 = _a.name, value = _a.value;
                    name_1 === 'data-etracker-seedid'
                        ? (seedId = helper_1.trim(value))
                        : /^data-etracker-extra-/.test(name_1)
                            ? (extra[name_1.replace('data-etracker-extra-', '')] = helper_1.trim(value))
                            : name_1 === 'data-etracker-seedname' && (seedName = helper_1.trim(value));
                }
                if (seedId) {
                    _this.click(seedId, { seedName: seedName, extra: extra });
                    break;
                }
                target = target.parentElement;
            }
        });
    };
    ETracker.prototype._logError = function (message) {
        console.error("[" + this.logTag + " warn]: " + message);
    };
    ETracker.prototype._validate = function () {
        var errorMessage = '';
        if (this.config) {
            var _a = this.config, userid = _a.userid, terminal = _a.terminal, server = _a.server;
            terminal
                ? server
                    ? (userid || (errorMessage = '缺少用户身份唯一标识：[userid]'))
                    : (errorMessage = '缺少接受埋点的服务器地址：[server]')
                : (errorMessage = '缺少移动端/PC端标识：[terminal]');
            if (!errorMessage) {
                if (this.config.terminal === 'H5') {
                    var _b = this.config, appid = _b.appid, appVersion = _b.appVersion, sourceType = _b.sourceType, did = _b.did, ch = _b.ch, brand = _b.brand, systemVersion = _b.systemVersion, network = _b.network;
                    appid
                        ? appVersion
                            ? sourceType
                                ? did
                                    ? ch
                                        ? brand
                                            ? systemVersion
                                                ? (network || (errorMessage = '缺少当前网络环境：[network]'))
                                                : (errorMessage = '缺少用户手机操作系统版本号：[systemVersion]')
                                            : (errorMessage = '缺少用户手机品牌：[brand]')
                                        : (errorMessage = '缺少APP所属渠道：[ch]')
                                    : (errorMessage = '缺少用户设备的设备号：[did]')
                                : (errorMessage = '缺少APP应用产品形态：[appType]')
                            : (errorMessage = '缺少APP应用版本号：[appVersion]')
                        : (errorMessage = '缺少APP应用名称：[appid]');
                }
                else {
                    var _c = this.config, webID = _c.webID, webVersion = _c.webVersion;
                    webID
                        ? (webVersion || (errorMessage = '缺少PC端应用版本号：[webVersion]'))
                        : (errorMessage = '缺少PC端应用名称：[webID]');
                }
            }
        }
        else {
            errorMessage = '缺少初始化配置项！请在调用 init 方法时传入。';
        }
        errorMessage && this._logError(errorMessage);
    };
    ETracker.prototype._send = function (result) {
        var url = result.url, data = result.data;
        if (url) {
            this.debug && console.log("%cETracker Log%c " + JSON.stringify(result), 'color:#fff;padding:4px 6px;background-color:#1890FF;', 'color:#333;');
            this.onReport(url, data);
        }
    };
    ETracker.prototype._proceed = function (input) {
        if (!this.config)
            return;
        var seedId = input.seedId, actionType = input.actionType, seedName = input.seedName, extra = input.extra;
        var _a = this.config, server = _a.server, debug = _a.debug, terminal = _a.terminal, rest = __rest(_a, ["server", "debug", "terminal"]);
        var data = __assign(__assign(__assign({ et: "" + Date.now(), eventEnName: seedId, eventCnName: seedName, eventType: actionType }, extra), rest), (this.detect || {}));
        this._send({ url: server, data: data });
    };
    ETracker.prototype.init = function (config) {
        if (this.config) {
            this._logError('重复调用 init 方法，应该只被调用一次。');
        }
        this.config = config;
        this.debug = !!(config === null || config === void 0 ? void 0 : config.debug);
        this.onReport = config.onReport;
        if (this.config.terminal === 'PC') {
            this.detect = helper_1.detect();
        }
        this._validate();
        this._monitorClickAction();
    };
    ETracker.prototype.click = function (seedId, options) {
        this._proceed(__assign({ seedId: seedId, actionType: 'click' }, options));
    };
    ETracker.prototype.startPageView = function (seedId, options) {
        if (!this.pageViewTimeMap) {
            this.pageViewTimeMap = {};
        }
        this.pageViewTimeMap[seedId] = Date.now();
        this._proceed(__assign({ seedId: seedId, actionType: 'start-view' }, options));
    };
    ETracker.prototype.startPageViewStatic = function (seedId) {
        if (!this.pageViewTimeMap) {
            this.pageViewTimeMap = {};
        }
        this.pageViewTimeMap[seedId] = Date.now();
        this.staticView = true;
    };
    ETracker.prototype.endPageView = function (seedId, options) {
        if (!this.pageViewTimeMap) {
            this.pageViewTimeMap = {};
        }
        var startTime = this.pageViewTimeMap[seedId];
        var duration = options.extra.duration;
        if (!duration && startTime) {
            duration = Date.now() - startTime;
            options.extra.duration = duration;
        }
        this._proceed(__assign({ seedId: seedId, actionType: this.staticView ? 'view' : 'end-view' }, options));
        this.staticView && (this.staticView = false);
    };
    ETracker.prototype.pageView = function (seedId, options) {
        this._proceed(__assign({ seedId: seedId, actionType: 'view' }, options));
    };
    return ETracker;
}());
exports["default"] = new ETracker();
